import React from 'react';
import {useHistory} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import '../view/css/SignupModal.css';
import '../view/css/Home.css';
import {SignupModalView} from '../view/SignUpModalView';

import { v4 as uuidv4 } from 'uuid';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";



export function SignupModal() {
    const [open, setOpen] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [username, setUserName] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [passwordTwo, setPasswordTwo] = React.useState("");
    const [error, setError] = React.useState(false);
    const [id, setId] = React.useState("");
    const [user_error, setUserError] = React.useState(false);
    const [email_error, setEmailError] = React.useState(false);


    var firestore = firebase.firestore();
    const vb = firestore.collection("Users");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setError(false);
        setEmail("");
        setUserName("");
        setPassword("");
        setPasswordTwo("");
    };
  
    const signup = async (e) => {
        var login_possible = true;
        var valid_email = true;
        var user_valid = true;
        e.preventDefault();
        if(email == "" || email.length == 0){
         
            setEmailError(true);
        }
    
        if (!(/^[a-zA-Z0-9]+@[ucsd]+\.[edu]+$/.test((email.toLowerCase())))) { 
            valid_email = false; 
            setEmailError(true);
            
        }
        if(username == "" || username.length == 0){
            setUserError(true);
            user_valid = false;
        }
        if (password != passwordTwo) {
            setError(true);
            return
        }
        if(email != "" || email.length != 0){
        var creation_possible = true;
        const db = firestore.collection("Users").doc(email.toLowerCase());
        const this_one = await db.get();
        
        if(this_one.exists){
            creation_possible=false;
            setError(error);
        }
        if(creation_possible && valid_email && user_valid){
        vb.doc(email.toLowerCase()).set({

            username: username,
            email: email,
            id: email.toLowerCase(),
            password: password,
            interests: [],
            profile_pic: "",
            subscriptions: [],
            type: "Student",
            liked_events:[],
            events: [],
            notification: [],
        });
   
   let allPromises =  firebase.auth().createUserWithEmailAndPassword(email.toLowerCase(), password).then((u) => {
    }).then((u) => { console.log(u + "email.toLowerCase")})
    .catch((error) => {
        console.log(error);
        setError(true);
        console.log("THERE IS INDEED AN ERROR");
        login_possible = false;
       
    })
    login();
}
        }


      
      
   
   
        //login();
        
    }

    const login = (e) => {
        if(!error){
        console.log("enter login")
        firebase.auth().signInWithEmailAndPassword(email, password).then((u) => {
        }).catch((error) => {
            console.log(error);
        });
    }
    

    }
    const inputUser = (e) => {
        setUserName(e.target.value)
    }
    const inputEmail = (e) => {
       
        setEmail(e.target.value)
    }

    const inputPassword = (e) => {
        setPassword(e.target.value)
    }

    const inputPasswordTwo = (e) => {
        setPasswordTwo(e.target.value)
    }

    return(
        <SignupModalView signup={signup} handleClickOpen={handleClickOpen} handleClose={handleClose} open={open} error={error} email_error={email_error} user_error={user_error} inputEmail={inputEmail} email={email} inputUser={inputUser} username={username} inputPassword={inputPassword} password={password} inputPasswordTwo={inputPasswordTwo} passwordTwo={passwordTwo}/>
    );
}